import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Box } from "@chakra-ui/core"

export type StoreType = "playstore" | "appstore" | "amazonstore"

interface Props {
  gameId: string
  type: StoreType
  url: string
}

const StoreButton: React.FC<Props> = ({ gameId, type, url }) => {
  const data = useStaticQuery(graphql`
    query {
      playstoreDesktop: file(relativePath: { eq: "google-en.png" }) {
        childImageSharp {
          fixed(height: 50, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      appstoreDesktop: file(relativePath: { eq: "apple-en.png" }) {
        childImageSharp {
          fixed(height: 50, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      amazonstoreDesktop: file(relativePath: { eq: "amazon-en.png" }) {
        childImageSharp {
          fixed(height: 50, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <Box>
      <a
        rel="noopener"
        href={url}
        id={`store-link-${gameId}-${type}`}
        aria-label={`Go to the ${type}`}
        style={{ display: "block" }}
        target="_blank"
      >
        <Img fixed={data[`${type}Desktop`].childImageSharp.fixed} />
      </a>
    </Box>
  )
}

export default StoreButton
